import o from"jwt-decode";const t=t=>o(t);export{t as decodeRoqToken};